import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Spinner,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { deleteDocuments, fetchAllDocument, fetchDocumentTableColumnNames, saveDocumentDetails, updateDocument, retryDocumentFile, mergeDocumentJson } from "../../../slices/AIDoc/thunk"; 
import { fetchParentCategories, updateUserPreference} from "../../../slices/thunks"; 
import DeleteModal from "../../../Components/Common/DeleteModal";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../../Components/Hooks/usePermissions";
import { fetchAllTags, fetchCategories, uploadDocumentFile, updateDocumentJson } from "../../../slices/AIDoc/thunk";
import EditDocDetails from "../../../Components/Common/AIDocForm/EditDocDetails";
import { getDocuments, updateFileProcessingStatus, updateLargeFileProcessingStatus } from "../../../slices/AIDoc/reducer";
import FileCommentModal from "../../../Components/Common/Modal/FileCommentModal";
import FileAssignModal from "../../../Components/Common/Modal/FileAssignModal";
import MultiFileModal from "../../../Components/Common/Modal/MultiFileModal";
import SaveFileModal from "../../../Components/Common/Modal/SaveFileModal";
import SectionModal from "../../../Components/Common/Modal/SectionModal";
import { useSocket } from "../../../hooks/useSocket";
import { fetchUsers } from "../../../slices/thunks";
import Cookies from 'js-cookie';

const labels = [
  {
    id: 1,
    labelName: "DocName",
    fieldName: "text-box",
    name: "OriginFileName",
    value: "DocName",
    required: true,
    errorMessage: "DocNameRequired"
  },
  {
    id: 2,
    labelName: "Title",
    fieldName: "text-box",
    name: "FileTitle",
    value: "Title",
    required: true,
    errorMessage: "TitleRequired"
  },
  {
    id: 3,
    labelName: "Category",
    fieldName: "select-category",
    name: "CategoryID",
    required: true,
    errorMessage: "CategoryRequired",
  },
  {
    id: 4,
    labelName: "SubCategory",
    fieldName: "select-subcategory",
    name: "SubCategoryID",
    required: true,
    errorMessage: "SubCategoryRequired",
  },
  {
    id: 5, 
    labelName: "Tags",
    fieldName: "multiselect-create-dropdown",
    name: "TagID",
    value: "Tags",
    required: true,
    errorMessage: "TagsRequired",
  },
  {
    id: 6,
    labelName: "Description",
    fieldName: "textarea", // changed from "text-box"
    name: "FileDesc",
    value: "Description",
    required: true,
    errorMessage: "DescriptionRequired"
  },
];

const tabObj = {
  1: 'bg-process',  
  4: 'current',
  98: 'data-entry',
  118: 'under-review'
}

function Documentmanagement() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = getAuthUser();
  const { socket, isConnected } = useSocket();
  const [searchParams, setSearchParams] = useSearchParams();

  const [show, setShow] = useState(false);
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState({
    Status: searchParams.get("status") || "",
    CategoryID: searchParams.get("categoryId") || "",
  });
  const [selectedIds, setSelectedIds] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);  
  const [deleteModal, setDeleteModal] = useState(false); 
  const [commentModal, setCommentModal] = useState(false); 
  const [selectedColumns, setSelectedColumns] = useState([]);

  const [showMultiLaw, setShowMultiLaw] = useState(false); 
  const [messages, setMessages] = useState([]);

  const [showConfirm, setShowConfirm] = useState(false);
  const [showSections, setShowSections] = useState(false);
  const [showStatusConfirm, setShowStatusConfirm] = useState(false);
  const [activeTab, setActiveTab] = useState(searchParams.get("status") ? searchParams.get("status") : tabObj[user.RoleID] || "current");

  const { 
    documents, 
    documentsLoading, 
    Headerloading,
    tableColumnNames, 
    parentCategories
   } = useSelector(
    (state) => ({
      documents: state.AIDoc.documents,
      documentsLoading: state.AIDoc.documentsLoading,
      Headerloading: state.AIDoc.Headerloading,
      tableColumnNames: state.AIDoc.tableColumnNames, 
      parentCategories: state.Category.parentCategories
    })
  );
  
  // Compute permission
  const permission = (() => {
    return usePermissions(2, 7);
  })();

  const handleTabChange = (tab) => {
    const updatedFilter = {...filter, ['Status']: tab};
    
    setFilter((prev) => ({
      ...prev,
      ['Status']: tab
    }))
    
    const newParams = {};
    if (updatedFilter.Status) newParams.status = updatedFilter.Status;
    if (updatedFilter.CategoryID) newParams.categoryId = updatedFilter.CategoryID;

    setSearchParams(newParams);
    setActiveTab(tab);
  }

  const handlefilter = (e) => {
    const { name, value } = e.target;
    const updatedFilter = {...filter, [name]: value};
    
    setFilter((prev) => ({
      ...prev,
      [name]: value
    }))
    
    const newParams = {};
    if (updatedFilter.Status) newParams.status = updatedFilter.Status;
    if (updatedFilter.CategoryID) newParams.categoryId = updatedFilter.CategoryID;

    setSearchParams(newParams);
  }

  const handleViewClick = (item) => {
    if (item && item.FileURL) {
      window.open(item.FileURL, '_blank', 'noopener,noreferrer');
    } else {
      toast.error(t("FileURLNotAvailable", "File URL is not available for this document."));
    }
  };

  const handleCommentClick = (item) => {
    setSelectedRow(item);
    setCommentModal(true);  
  }

  const handleRetry = (item) => {
    const data = {
      DocID: item.ID,
      JsonURL: null,   
      IsProcessed: null,
      URL: item.JsonURL,
      DocumentTypeID: item.DocumentTypeID,
      ParaLegalIDs: item.ParaLegalIDs,
      IsRetry: false // set it intentionally
    }

    if (item.IsLargeFile) {
      dispatch(updateLargeFileProcessingStatus({ ID: item.ID, ModifiedByID: user.ID  }))
      dispatch(updateDocumentJson(data));
      item.LargeDocumentFiles.forEach((file) => {
        try {
          // const formData = new FormData();
          // formData.append("IsBook", false);
          // formData.append("DBID", file.ID);
          // formData.append("fileUrl", file.FileURL);
          // formData.append("DocumentTypeID", 4);
          // formData.append("IsLargeFile", true);
          // formData.append("SaveJSON", true);
          
          // dispatch(uploadDocumentFile({ formData, onProgress, isMultiUpload: false }));

          // const formData = new FormData();
          // formData.append("DocID", item.ID);
          // formData.append("DocURL", item.FileURL);
          // formData.append("JsonURL", item.JsonURL);
          // formData.append("IsLargeFile", true);

          let formData = {
            UserID: user.ID,
            DocID: item.ID,
            DocURL: item.FileURL,
            JsonURL: item.JsonURL,
            StatusID: [12, 13].includes(item.Status) ? item.Status: 3,
            IsLargeFile: false,
            IsRetry: true
          }

          formData = JSON.stringify(formData);

          dispatch(retryDocumentFile({ formData, onProgress, isMultiUpload: false }));
        } catch (error) {
          console.error("Error in handleButtonClick:", error);
        }
      })

    } else {
      try {
        // const formData = new FormData();
        dispatch(updateFileProcessingStatus({ ID: item.ID, JsonURL: null, IsProcessed: false, Status: 10, ModifiedByID: user.ID}))
        dispatch(updateDocumentJson(data));
        // formData.append("IsBook", false);
        // formData.append("DBID", item.ID);
        // formData.append("fileUrl", item.FileURL);
        // formData.append("DocumentTypeID", 4);
        // formData.append("IsLargeFile", false);
        // formData.append("SaveJSON", true);
        
        // dispatch(uploadDocumentFile({ formData, onProgress, isMultiUpload: false }));

        // const formData = new FormData();
        // formData.append("DocID", item.ID);
        // formData.append("DocURL", item.FileURL);
        // formData.append("JsonURL", item.JsonURL);
        // formData.append("IsLargeFile", false);

        let formData = {
          UserID: user.ID,
          DocID: item.ID,
          DocURL: item.FileURL,
          JsonURL: item.JsonURL,
          // StatusID: item.Status,
          StatusID: [12, 13].includes(item.Status) ? item.Status: 3,
          IsLargeFile: false,
          IsRetry: true
        }

        formData = JSON.stringify(formData);

        dispatch(retryDocumentFile({ formData, onProgress, isMultiUpload: false }));
      } catch (error) {
        console.error("Error in handleButtonClick:", error);
      }
    }
  }

  const handleReassign = (item) => {  
    setSelectedRow(item);
    setShowConfirm(true);
  }

  const onReassignClickHandler = (paraLegalIDs) => {
    const data = {
      DocID: selectedRow.ID,
      JsonURL: selectedRow.JsonURL,
      IsProcessed: true,
      IsSaved: true,
      Status: 3,
      DocumentTypeID: selectedRow.DocumentTypeID,
      ParaLegalIDs: paraLegalIDs,
    }
    
    dispatch(updateDocumentJson(data))
    setShowConfirm(false);
  }

  const handleSaveDocument = (item) => {
    setSelectedRow(item);
    setShowStatusConfirm(true);
  }

  const onSaveClickHandler = () => {
    dispatch(updateDocumentJson({ 
      DocID: selectedRow.ID, 
      JsonURL: selectedRow.JsonURL,
      // Status: [12, 13].includes(selectedRow.Status) ? selectedRow.Status : 3,
      Status: 3,
      IsSaved: true,
      IsProcessed: selectedRow.IsProcessed,
      ParaLegalIDs: selectedRow.ParaLegalIDs,
      // IsRetry: true
    }))
    setSelectedRow({});
    setShowStatusConfirm(false);
  }

  const onSaveSectionsClickHandler = () => {
    dispatch(updateDocument({ 
      DocumentID: selectedRow.ID, 
      Sections: selectedRow.Sections,
      ArticleRange: selectedRow.ArticleRange
    }))
    setSelectedRow({});
    setShowSections(false);
  }
 
  const onEditClickHandler = (category, value) => {
    setSelectedRow(category);
    setIsAddOrEdit(value);
    setShow(true);
  };  

  const handleDeleteActionClick = (item) => {
    setSelectedIds([item.ID || item.Id]);
    setDeleteModal(true);
  };

  // const onProgress = ({ event, data }) => {
  //   try {
  //     const parsedData = typeof data === "string" ? JSON.parse(data) : data;

  //     if (event === "file_ocr_done") {
  //       const data = {
  //         DocumentID: parsedData.DBID,
  //         OriginFileName: parsedData.text?.originalFileName,   
  //         Tags: parsedData.text?.tags
  //       }
  //       dispatch(updateDocument(data)).unwrap()
  //       .then(() => {
  //         console.log("saved successfully");
  //       })
  //       .catch((error) => {
  //         console.error("save failed:", error);
  //       });
  //     }
      
  //     if (event === "file_processed") {
  //       const { DBID, url } = parsedData;
  //       dispatch(updateFileProcessingStatus({ ID: DBID, JsonURL: url, IsProcessed: true, ModifiedByID: user.ID }))
  //     }
      
  //   } catch (error) {
  //     console.error("Failed to process stream event:", error, data);
  //   }
  // };

  const onProgress = ({ event, data }) => {
    try {
      const parsedData = typeof data === "string" ? JSON.parse(data) : data;

      if (event === "multiple_laws_detected") {
        setShowMultiLaw(true);
        setMessages(parsedData?.titles || [])
      }

      if (event === "new_json") {
        const { DocID, JsonURL = null } = parsedData;
        if (JsonURL) {
          dispatch(updateDocumentJson({ DocID: DocID, JsonURL: JsonURL, IsProcessed: true }))
        }
        dispatch(updateFileProcessingStatus({ ID: DocID, JsonURL: JsonURL, IsProcessed: JsonURL ? true : null, ModifiedByID: user.ID }))
      }
      
    } catch (error) {
      console.error("Failed to process stream event:", error, data);
    }
  };

  const handleButtonClick = async (item, title, type) => {
    if (type == "view") {
      navigate('/ai/document-details', { 
        state:  {
          DocID: item.ID,
          FileName: item.FileName,
          FileURL: item.FileURL,
          JsonURL: item.JsonURL,
          IsSaved: item.IsSaved,
          Status: item.Status,
          ReviewedBy: item.ReviewedBy,
          ParaLegalIDs: item.ParaLegalIDs,
          DocumentTypeID: item.DocumentTypeID
        }
      })
    } else if (type == 'json-editor') {
      navigate('/ai/json-editor', { 
        state:  {
          DocID: item.ID,
          FileName: item.FileName,
          FileURL: item.FileURL,
          JsonURL: item.JsonURL,
          IsSaved: item.IsSaved,
          Status: item.Status,
          ReviewedBy: item.ReviewedBy,
          IsProcessed: item.IsProcessed,
          ParaLegalIDs: item.ParaLegalIDs,
          DocumentTypeID: item.DocumentTypeID
        }
      })
    } else if (type == "view-metadata") {
      navigate('/ai/document-chunks', { 
        state:  {
          DocID: item.ID,
          FileURL: item.FileURL,
          JsonURL: item.JsonURL,
          IsSaved: item.IsSaved,
          ReviewedBy: item.ReviewedBy,
          DocumentTypeID: item.DocumentTypeID
        }
      })

    } else if (type == 'configuration') {
      setSelectedRow(item);
      setShowSections(true);

    } else if (type == 'get-json') {
      if (item.IsLargeFile) {
        try {
          const formData = {
            DocID: item.ID
          }
          dispatch(updateFileProcessingStatus({ ID: item.ID, JsonURL: null, IsProcessed: false, Status: 2, ModifiedByID: user.ID}))
          dispatch(mergeDocumentJson({ formData }));
        } catch (error) {
          console.error("Error in handleButtonClick:", error);
        }
      } else {
        try {
          // const formData = new FormData();
          dispatch(updateFileProcessingStatus({ ID: item.ID, JsonURL: null, IsProcessed: false, Status: 2, ModifiedByID: user.ID}))
          // formData.append("IsBook", false);
          // formData.append("DBID", item.ID);
          // formData.append("fileUrl", item.FileURL);
          // formData.append("DocumentTypeID", 4);
          // formData.append("IsLargeFile", false);
          // formData.append("SaveJSON", true);
          
          // dispatch(uploadDocumentFile({ formData, onProgress, isMultiUpload: false }));

          let formData = {
            UserID: user.ID,
            DocID: item.ID,
            DocURL: item.FileURL,
            JsonURL: item.JsonURL,
            // StatusID: item.Status,
            StatusID: 3,
            IsLargeFile: false,
            IsRetry: false
          }

          formData = JSON.stringify(formData);

          dispatch(retryDocumentFile({ formData, onProgress, isMultiUpload: false }));
        } catch (error) {
          console.error("Error in handleButtonClick:", error);
        }
      }
    } else if (type == 'retry') {
      handleRetry(item);
    }
  }

  const actionConfig = {
    showCheckboxColumn: false, 
    view: { 
      icon: "ri-eye-line",
      tooltip: t("View"),
      onClick: handleViewClick,
      isVisible: (item, perm) => perm?.CanView, // Show for all items, or add permission check: perm?.CanView
    },
    retry: { 
      icon: "ri-restart-line",
      tooltip: t("Retry"),
      onClick: handleRetry,
      // isVisible: (item, perm) =>  item.IsProcessed != false && !item.ReviewedByID && (user.ID == 1 || user.ID == 4803) ? true : false,
      isVisible: (item, perm) =>  item.IsProcessed != false && [1, 4, 118].includes(user.RoleID) && perm?.CanActive  ? true : false,
    },
    comment: { 
      icon: "ri-file-close-line",
      tooltip: t("File Issue"),
      onClick: handleCommentClick,
      isVisible: (item, perm) => perm?.CanActive || [98].includes(user.RoleID) ? true : false, // Show for all items, or add permission check: perm?.CanView
    },
    save: {
      icon: "ri-save-line",
      tooltip: t("Save"),
      onClick: handleSaveDocument,
      isVisible: (item, perm) => perm?.CanActive && [1, 4].includes(user.RoleID) ? true : false, 
    },
    reassign: {
      icon: "ri-repeat-line",
      tooltip: t("Re-assign"),
      onClick: handleReassign,
      isVisible: (item, perm) => perm?.CanActive && [1, 4, 118].includes(user.RoleID) ? true : false, 
    },
    edit: {
      icon: "ri-edit-2-line",
      tooltip: "Edit",
      isVisible: (item, perm) => perm?.CanEdit,
    },
    delete: {
      icon: "ri-delete-bin-2-line",
      tooltip: t("Delete"),
      onClick: handleDeleteActionClick,
      isVisible: (item, perm) => (user.RoleID == 98 && item.JsonURL) ? false : (user.RoleID == 118 && item.ReviewedByID) ? false : perm?.CanDelete
    },
  };

  const confirmDelete = () => {
    dispatch(deleteDocuments({ DocumentIDs: selectedIds, DocumentTypeID: 4 })) 
      .then(() => {
        toast.success(t("Documents deleted successfully"));
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  const onSubmitDocDetailsHandler = (values, { resetForm }) => {

    // Base object with common properties
    const Obj = {
      ID: selectedRow.ID ? selectedRow.ID : null,
      FileName: values.OriginFileName,
      FileTitle: values.FileTitle,
      FileDesc: values.FileDesc,
      CategoryID: values.CategoryID,
      SubCategoryID: values.SubCategoryID,
      tagNames: values.TagID ? values.TagID.map(tag => tag.label) : [],
    };

    dispatch(saveDocumentDetails(Obj));

    resetForm();
    setShow(false);    
  };

  const saveUserPreferences = async () => {
    const preferencesPayload = {
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ID] = selectedColumns.includes(column.ID);
        return acc;
      }, {}),
    };

    setModalOpen(false);
    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap(); 
      await dispatch(
        fetchDocumentTableColumnNames({ 
          module: "AI_DOCUMENTS", 
        }) 
      );

    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const handleCommentSubmit = (value) => {
    // e.preventDefault();
    const data = {
      DocumentID: selectedRow.ID, 
      Comment: value.comment, 
      Status: value.reason
    }

    if (user.RoleID == 118) {
      data.IsSaved = false
    }
    dispatch(updateDocument(data));
    setCommentModal(false);
  }

  const handleDocumentResponse = (response) => {
    const data = JSON.parse(response) || {};
    if (Array.isArray(data.Data) && data.Data?.length) {
      dispatch(getDocuments({ Data: data.Data }))
    }
  }

  const Documents = useMemo(() => {
    if (!documents) return [];

    return documents.filter((item) => {
      let isMatch = false;

      switch (activeTab) {
        case "data-entry":
          // isMatch = item.Status === 2 && (!item.JsonURL || user.ID == item.CreatedByID);
          isMatch = true;
          break;
        case "crawl":
          isMatch = item.Status == 99; // only crawl docs
          break;
        case "bg-process":
          isMatch = user.RoleID == 1 && (item.Status == 11 || item.IsProcessed == false);
          break;
        case "current":
          isMatch = item.Status == 2 && (item.JsonURL || (user.ID == item.ModifiedByID && item.Status == 10));
          break;
        case "under-review":
          isMatch = item.Status == 3 && item.IsSaved == true;
          break;
        case "reviewed":
          isMatch = item.Status == 4;
          break;
        case "legal-issue":
          isMatch = item.Status == 12 || (user.ID == item.ModifiedByID && item.Status == 10);
          break;
        case "document-issue":
          isMatch = item.Status == 13 || (user.ID == item.ModifiedByID && item.Status == 10);
          break;
        case "re-check":
          isMatch = item.Status == 14;
          break;
        default:
          isMatch = true;
      }

      // Apply Category filter (only if selected)
      if (filter.CategoryID) {
        isMatch = isMatch && item.CategoryID === filter.CategoryID;
      }

      return isMatch;
    });
  }, [documents, activeTab, filter.CategoryID, user.ID]);

  useEffect(() => {
    if (!isConnected) return;

    const payload = {
      authorization: Cookies.get('authorization'),
      DeviceID: Cookies.get('deviceId'),
      langid: localStorage.getItem("langId"),
      DocumentTypeID: 4,
      IsSaved: [1, 4, 98].includes(user.RoleID) ? false : true
    }
      
    socket?.emit("GetLawDocument", JSON.stringify(payload));
    socket?.on("LawDocumentResponse", handleDocumentResponse)

    return () => {
      socket?.emit("StopLawDocument")
      socket?.off("LawDocumentResponse", handleDocumentResponse)
    }

  }, [isConnected])

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(fetchDocumentTableColumnNames({ module: "AI_DOCUMENTS" })); 
        dispatch(fetchAllDocument({DocumentTypeID: 4, IsSaved: [1, 4, 98].includes(user.RoleID) ? false : true }));
        dispatch(fetchUsers({ IsSystemUser: true, IsActive: true, RoleID: 118 }));
        // dispatch(fetchParentCategories({ DocType: 4 })); 
        // dispatch(fetchCategories());
        dispatch(fetchAllTags());
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [dispatch]); 


  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Document")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
              <Row className="g-4">
                    <Col className="col-sm-auto">
                      <div>
                        {/* <Button
                          className="btn btn-soft-danger ms-2 me-2"
                          onClick={() => setDeleteModal(true)}
                          disabled={selectedIds.length === 0 || !permission.CanDelete}
                        >
                          <i className="ri-delete-bin-2-line"></i>
                        </Button> */}
                        {/* { ([1, 98].includes(user.RoleID)) && */}
                        { permission.CanAdd &&
                          <div className="d-flex gap-5">
                            {/* <Button
                              color="secondary"
                              className="add-btn"
                              id="create-btn"
                              // disabled={isDisabled}
                              onClick={() => navigate("/ai/document-upload")}
                            >
                              <i className="ri-upload-cloud-2-line align-bottom me-1"></i>
                              {t("Upload Document")}
                            </Button> */}
                            <Button
                              color="secondary"
                              className="add-btn"
                              id="create-btn"
                              // disabled={isDisabled}
                              onClick={() => navigate("/ai/large-document-upload")}
                            >
                              <i className="ri-upload-cloud-2-line align-bottom me-1"></i>
                              {t("Upload Document")}
                            </Button>
                          </div>
                        }
                      </div>
                    </Col>
                    {/* { (user.RoleID == 1 || user.RoleID == 98) &&
                      <Col md={2}>
                        <Input
                          type="select"
                          id="file-status"
                          name="Status"
                          value={filter.Status}
                          onChange={handlefilter}
                        >
                          <option value="">{t("All")}</option>
                          <option value="1">{t("File Upload")}</option>
                          <option value="2">{t("Data Extracted")}</option>
                          <option value="3">{t("Saved Data")}</option>
                          <option value="4">{t("Reviewed Data")}</option>
                          <option value="5">{t("File Issues")}</option>
                        </Input>
                      </Col>
                    } */}

                    {/* <Col md={2}>
                      <Input
                        type="select"
                        id="file-category"
                        name="CategoryID"
                        value={filter.CategoryID}
                        onChange={handlefilter}
                      >
                        <option value="">{t("All")}</option>
                        {parentCategories.map((item) => {
                          return <option value={item.ID} key={item.ID}>{i18n.language == 'en' ? item.NameEn : item.NameAr}</option>
                        })}
                      </Input>
                    </Col> */}

                    <Col className="col-sm">
                      <div className="d-flex justify-content-sm-end">
                        <Button
                          className="btn btn-soft"
                          onClick={() => setModalOpen(true)}
                          disabled={documentsLoading} // Use documentsLoading
                        >
                          <i className="ri-filter-3-line"></i>
                        </Button>
                        <div className="search-box ms-2 me-2">
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={t("Search")}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </div>
                    </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
                <Nav tabs style={{ marginBottom: 16 }}>
                  { [1, 98].includes(user.RoleID) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "data-entry" ? "active" : ""}
                        onClick={() => handleTabChange("data-entry")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('Data Entry')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                  { [1, 98].includes(user.RoleID) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "crawl" ? "active" : ""}
                        onClick={() => handleTabChange("crawl")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('Crawl')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                  { [1].includes(user.RoleID) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "bg-process" ? "active" : ""}
                        onClick={() => handleTabChange("bg-process")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('BG Process')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                  { [1, 4, 98].includes(user.RoleID) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "current" ? "active" : ""}
                        onClick={() => handleTabChange("current")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('Current Jobs')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                  { ([1, 4, 118].includes(user.RoleID)) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "under-review" ? "active" : ""}
                        onClick={() => handleTabChange("under-review")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('Under Review')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                  { ([1, 4].includes(user.RoleID)) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "reviewed" ? "active" : ""}
                        onClick={() => handleTabChange("reviewed")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('Reviewed')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                  { ([1, 4, 118].includes(user.RoleID)) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "legal-issue" ? "active" : ""}
                        onClick={() => handleTabChange("legal-issue")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('Legal Issue')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                  { ([1, 4, 118].includes(user.RoleID)) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "document-issue" ? "active" : ""}
                        onClick={() => handleTabChange("document-issue")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('Document Issue')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                  { ([1, 4, 118].includes(user.RoleID)) && <>
                    <NavItem>
                      <NavLink
                        className={activeTab === "re-check" ? "active" : ""}
                        onClick={() => handleTabChange("re-check")}
                        style={{ cursor: "pointer" }}
                      >
                        {t('Re-check')}
                      </NavLink>
                    </NavItem>
                  </>
                  }
                </Nav>
              
                {documentsLoading || Headerloading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner
                      style={{ height: "3rem", width: "3rem" }}
                      className="me-2"
                    >
                      Loading...
                    </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    <CommonDataTable
                      data={Documents} 
                      tableColumnNames={Array.isArray(tableColumnNames) ? tableColumnNames : []} // Ensure tableColumnNames is an array
                      searchTerm={searchTerm}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      onEditClickHandler={onEditClickHandler}
                      handleButtonClick={handleButtonClick}
                      actionConfig={actionConfig}
                      permission={permission}
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

       {/* Modal  */}
       <CommonAddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitDocDetailsHandler}
        labels={labels}
        isAddOrEdit={isAddOrEdit}
        selectedItemData={selectedRow}
        FormBody={EditDocDetails}
        title={t("EditDocDetails")}
        size="xl"
      />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={Array.isArray(tableColumnNames) ? tableColumnNames : []} // Ensure columns is an array
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={saveUserPreferences}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={t("confirmDelete")}
      />

      {/* Comment Modal  */}
      <FileCommentModal
        title={t("Comment")}
        show={commentModal}
        selectedRow={selectedRow} 
        setShow={setCommentModal}
        onSubmitHandler={handleCommentSubmit}
      />

      {/* Assign Modal  */}
      <FileAssignModal
        show={showConfirm}
        doc={selectedRow}
        setShow={setShowConfirm}  
        onReassignClickHandler={onReassignClickHandler}
      />

      <MultiFileModal 
        show={showMultiLaw}
        setShow={setShowMultiLaw}
        messages={messages}
        setMessages={setMessages}
      />

      <SaveFileModal 
        show={showStatusConfirm}
        setShow={setShowStatusConfirm}
        onSaveClickHandler={onSaveClickHandler}
      />

      <SectionModal
        show={showSections}
        setShow={setShowSections}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        onSaveClickHandler={onSaveSectionsClickHandler}
      />

    </div>
  );
}

export default Documentmanagement;
